import { SudokuGameModel } from './sudoku-game.model';

export class InitSudokuGame {
  static readonly type = '[SudokuGame] Init';
  constructor(public payload: SudokuGameModel) {}
}

export class PersistSudokuState {
  static readonly type = '[SudokuGame] Persist game state';
  constructor(public payload: SudokuGameModel) {}
}
